"use strict";

export default class CollapsibleContent {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;
    this.state = {
      expanded: false,
      expandLabel: $(
        ".collapsible-content__collapsible__handle button",
        this.$selector
      ).data("expandlabel"),
      collapseLabel: $(
        ".collapsible-content__collapsible__handle button",
        this.$selector
      ).data("collapselabel"),
    };
    
    if (selfInit) this.init();
  }

  init() {
    if ((typeof this.$selector.data('dual-display') == 'undefined')) {
      if ($(window).width() >= 1024) {
        $(".collapsible-content__collapsible__content", this.$selector).show();
      }
    } else {
      this.$collapsibleRte = $(".collapsible-content__collapsible__content .rte", this.$selector);
      if (this.$collapsibleRte.is(':empty') || this.$collapsibleRte.html().trim() == "") {
        if ($(window).width() >= 1024) {
          $(".collapsible-content__collapsible__handle button", this.$selector).hide();
        }
      }
    }

    let resizeTimer;
    $(window).on('resize', () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        if ((typeof this.$selector.data('dual-display') == 'undefined')) {
          if ($(window).width() >= 1024) {
            $(".collapsible-content__collapsible__content", this.$selector).show();
          } else {
            if (!this.state.expanded) {
              $(".collapsible-content__collapsible__content", this.$selector).hide();
            }
          }
        } else {
          if ($(window).width() < 1024) {
            $(".collapsible-content__collapsible__handle button", this.$selector).show();
            if (this.state.expanded) {
              $('.desktopOnlyText', this.$selector).show();
            } else {
              $('.desktopOnlyText', this.$selector).hide();
            }
          } else {
            if (this.$collapsibleRte.is(':empty') || this.$collapsibleRte.html().trim() == "") {
              $(".collapsible-content__collapsible__handle button", this.$selector).hide();
            }
          }
        }
      }, 300);
    });
    
    $(".collapsible-content__collapsible__handle button", this.$selector).on(
      "click",
      (e) => {
        e.preventDefault();

        if (!this.state.expanded) {
          if ($(window).width() < 1024) {
            if ($('.desktopOnlyText', this.$selector).length) {
              $('.desktopOnlyText', this.$selector).slideDown(300);
            }
          }
          $(
            ".collapsible-content__collapsible__content",
            this.$selector
          ).slideDown(300, () => {
            this.$selector.addClass('content-expanded');
            $(".collapsible-content__collapsible__content", this.$selector)
              .parent()
              .addClass("expanded");
            $(
              ".collapsible-content__collapsible__handle button",
              this.$selector
            ).text(this.state.collapseLabel);
          });
        } else {
          if ($(window).width() < 1024) {
            if ($('.desktopOnlyText', this.$selector).length) {
              $('.desktopOnlyText', this.$selector).slideUp(300);
            }
          }
          $(
            ".collapsible-content__collapsible__content",
            this.$selector
          ).slideUp(300, () => {
            this.$selector.removeClass('content-expanded');
            $(".collapsible-content__collapsible__content", this.$selector)
              .parent()
              .removeClass("expanded");
            $(
              ".collapsible-content__collapsible__handle button",
              this.$selector
            ).text(this.state.expandLabel);
          });
        }

        this.state.expanded = !this.state.expanded;
      }
    );
  }
}
